import { createContext, useContext, useState, useEffect } from "react";
import React from "react";

const LanguageContext = createContext("da");

/*
 * This hook provides the current language
 */

export const useLanguage = () => useContext(LanguageContext);
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("da");

  useEffect(() => {
    const hashArray = window.location.hash.split("#");
    hashArray.shift();
    for (const hash of hashArray) {
      const [key, val] = hash.split("=");
      if (key === "lang") setLanguage(val);
      else setLanguage("da");
    }
  }, []);

  return (
    <LanguageContext.Provider value={language}>
      {children}
    </LanguageContext.Provider>
  );
};
